module.exports = __webpack_public_path__ + "logo.98b1d0be.png";